import React from "react";
import Link from "../../Link";
import Image from "next/image";

type Props = {
    id?: string,
    title: React.ReactNode;
    image: string,
    imageAlt?: string,
    imageWidth?: number,
    imageHeight?: number,
    list?: any,
    sectionRef?: any,
    key?: number,
    hasActionsDemo?: boolean,
    exploreBtn?: string;
    exploreLink?: string;
    docsLink?: string;
    docsLabel?: string;
};

const ProductFeatureSection: React.FC<Props> = ({ id, title, image, imageAlt, imageWidth = 640, imageHeight = 508, list, sectionRef, hasActionsDemo, exploreBtn, exploreLink, docsLink, docsLabel }) => {

    return (
        <div id={id} ref={sectionRef} className={"tab-features"}>
            <div className={"d-flex"}>
                <div className={"left-block"}>
                    <Image
                        src={image}
                        alt={imageAlt ?? ""}
                        width={imageWidth}
                        height={imageHeight}
                        // Not 100vw on small phones: layout is .container + padding (~362px wide in audits), not full 100vw — that forced ~750w (2x viewport). Tablet uses calc to approximate content width.
                        sizes="(max-width: 768px) 363px, (max-width: 991px) calc(100vw - 3rem), (max-width: 1200px) 45vw, 540px"
                        quality={82}
                        loading="lazy"
                        unoptimized={image.endsWith(".webp")}
                    />
                </div>
                <div className={`right-block steps-bg ${id}`}>
                    <div className={"heading d-flex"}>
                        <h4>{title}</h4>
                    </div>
                    <ul>
                        {list.map((item: string, index: number) => (
                            <li key={index}>{item}</li>
                        ))}
                        {hasActionsDemo && (
                            <div className="d-flex actions-demo-product-overview">
                                <Link
                                    href={exploreLink || "https://app.middleware.io/auth/register/"}
                                    target="_blank"
                                    className="sign-up ahref-btn primary"
                                >
                                    {exploreBtn || "Get Started Free"}
                                </Link>

                                <Link
                                    href={docsLink || "/docs/"}
                                    className="read-more"
                                >
                                    {docsLabel || "Book a Demo"}
                                </Link>
                            </div>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ProductFeatureSection;